import { graphql } from "~/gql";
export const COPY_LIBRARY_PHASE = graphql(/* GraphQL */ `
  mutation copyLibraryPhase($matterId: Float!, $phaseId: Float!) {
    copyLibraryPhase(matterId: $matterId, phaseId: $phaseId) {
      phase {
        ...PhaseParts
      }
      assumptions {
        ...AssumptionFragment
      }
      exclusions {
        ...ExclusionFragment
      }
      disbursements {
        ...DisbursementParts
      }
    }
  }
`);
